import {ButtonType} from '../button/ButtonType';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'mm-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {

    @Input()
    public style: ButtonType = 'primary';
}
